import {
  PlayArrow,
  Stop,
  Warning,
  Create,
  HelpOutline,
  Timer,
  FormatListBulleted,
} from "@material-ui/icons";
import { QuestionTypes } from "../utils/constants";

export const NodeIcons = {
  START: PlayArrow,
  END: Stop,
  WARNING: Warning,
};

export const QuestionTypeIcons = {
  [QuestionTypes.FREE_TEXT]: Create,
  [QuestionTypes.YES_NO]: HelpOutline,
  [QuestionTypes.TIME_DURATION]: Timer,
  [QuestionTypes.LIST]: FormatListBulleted,
};
